import './middle.css'
import React from 'react';
import pic from '../pictures/Image 564.png'
function Fourth() {
    return (
        <div className="whole1">
            <div className="schedule_button">
                <div className="firstline"></div>
                <div className="schedule">
                    <div>Scheduled a visit</div>
                </div>
                <div className="firstline1"></div>
            </div>
            <div className="Sphoto">
                <img src={pic} alt="" />
                <div className="Amenities">Amenities</div>
                <div className="upgrade">Upgrade To A Peaceful Lifestyle</div>
                <div className="luxary"><p>Luxury is what luxury can do for you. Our premium amenities lets you
                 enjoy the opulence while appreciating their functional importance in our grand design.</p></div>
                <div className="exploreButton">
                    <div>Explore Amenities</div>
                </div>
            </div>
        </div>
    );
}

export default Fourth